var _path, _path2, _g, _path3, _path4, _g2, _g3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchivedConclusionNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 242,
    viewBox: "0 0 296 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19569_43796)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.623 203.438C160.546 214.454 202.428 251.671 241.633 234.881C280.838 218.091 289.967 189.737 292.5 143.638C295.033 97.5398 247.299 38.4563 223.136 30.1627C163.289 9.621 149.432 -16.0924 117.193 15.4227C80.9281 50.8723 89.2204 55.3546 59.2567 86.892C40.0593 107.098 0.444193 118.602 0.362748 141.298C0.281308 163.993 -3.32549 209.761 32.4613 224.759C68.2481 239.758 81.4891 187.175 128.623 203.438Z",
    fill: "#00C6C6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19569_43796",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 293,
    height: 239
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.688 203.412C159.615 214.357 201.455 251.459 240.727 234.615C280 217.772 289.195 189.43 291.825 143.376C294.456 97.3225 246.803 38.3891 222.638 30.1484C162.784 9.73787 148.968 -15.9228 116.637 15.6175C80.2688 51.0955 88.5588 55.558 58.505 87.1165C39.2499 107.336 -0.421925 118.9 -0.550319 141.572C-0.678709 164.243 -4.38306 209.969 31.4026 224.886C67.1882 239.803 80.5488 187.252 127.688 203.412Z",
    fill: "#00C6C6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19569_43796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.085 65.7845C126.23 39.5889 107.156 0.33391 141.145 -2.85273C178.479 -6.35306 227.926 -22.2808 250.838 7.74516C275.922 40.6156 230.925 86.2889 239.711 126.313C246.645 157.9 295.367 172.617 294.083 204.74C292.815 236.46 264.585 266.511 233.782 274.668C203.683 282.638 176.617 254.194 146.894 243.716C129.541 237.599 58.0049 239.115 40.622 233.086C27.569 236.967 19.2517 276.955 -4.54636 210.18C-17.7444 186.359 34.6866 149.949 39.1633 123.493C44.674 90.9273 84.4193 91.3881 105.085 65.7845Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.079 23.212C187.349 59.1472 154.716 39.7917 135.436 74.9496C111.337 118.897 153.883 145.812 119.738 162.307C85.5938 178.803 35.3817 190.833 34.5994 206.936C33.9736 219.819 45.061 227.753 45.1436 229.355",
    stroke: "#5B686D",
    strokeWidth: 3,
    strokeDasharray: "16 12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219.703 238.031C213.264 216.126 207.271 168.673 234.819 154.104C269.255 135.893 277.794 169.092 283.054 166.27C287.262 164.013 289.976 156.434 290.807 152.927",
    stroke: "#5B686D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "15 12"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    y: 110.5,
    width: 153,
    height: 56.3222,
    rx: 4.63333,
    fill: "white",
    stroke: "#C8CDD8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.8447,
    y: 116.844,
    width: 53.9,
    height: 5.13333,
    rx: 2.56667,
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.8447,
    y: 133.956,
    width: 46.2,
    height: 5.13333,
    rx: 2.56667,
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.8447,
    y: 145.933,
    width: 140.311,
    height: 5.13333,
    rx: 2.56667,
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.8447,
    y: 154.489,
    width: 119.778,
    height: 5.13333,
    rx: 2.56667,
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.434,
    y: 133.956,
    width: 46.2,
    height: 5.13333,
    rx: 2.56667,
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.967,
    y: 115.133,
    width: 38.5,
    height: 8.55556,
    rx: 4.27778,
    fill: "#D1D4DB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.6,
    y: 115.133,
    width: 8.55556,
    height: 8.55556,
    rx: 4.27778,
    fill: "#D1D4DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8447 128.822L210.156 128.822",
    stroke: "#EFF2F7",
    strokeWidth: 0.855556
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.5,
    y: 176.5,
    width: 115,
    height: 42.1778,
    rx: 4.63333,
    fill: "white",
    stroke: "#C8CDD8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.1558,
    y: 181.156,
    width: 40.6,
    height: 3.86667,
    rx: 1.93333,
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.1558,
    y: 194.044,
    width: 34.8,
    height: 3.86667,
    rx: 1.93333,
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.1558,
    y: 203.067,
    width: 105.689,
    height: 3.86667,
    rx: 1.93333,
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.1558,
    y: 209.511,
    width: 90.2222,
    height: 3.86667,
    rx: 1.93333,
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.067,
    y: 194.044,
    width: 34.8,
    height: 3.86667,
    rx: 1.93333,
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.534,
    y: 179.867,
    width: 29,
    height: 6.44444,
    rx: 3.22222,
    fill: "#D1D4DB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.4,
    y: 179.867,
    width: 6.44444,
    height: 6.44444,
    rx: 3.22222,
    fill: "#D1D4DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1558 190.178L192.845 190.178",
    stroke: "#EFF2F7",
    strokeWidth: 0.855556
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.5,
    y: 35.5,
    width: 179,
    height: 66,
    rx: 5.5,
    fill: "white",
    stroke: "#C8CDD8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 43,
    width: 63,
    height: 6,
    rx: 3,
    fill: "#969696"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 63,
    width: 54,
    height: 6,
    rx: 3,
    fill: "#969696"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 77,
    width: 164,
    height: 6,
    rx: 3,
    fill: "#969696"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 87,
    width: 140,
    height: 6,
    rx: 3,
    fill: "#969696"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 63,
    width: 54,
    height: 6,
    rx: 3,
    fill: "#969696"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 41,
    width: 45,
    height: 10,
    rx: 5,
    fill: "#D1D4DB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 41,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#D1D4DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58 57L222 57",
    stroke: "#EFF2F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3003 98.5779C19.6752 98.2627 20.2491 98.3115 20.5822 98.7076L20.8902 99.0739C21.2151 99.4604 21.1728 100.044 20.7979 100.359L4.82443 113.79C4.44855 114.106 3.86655 114.048 3.54158 113.661L3.23363 113.295C2.90055 112.899 2.95093 112.325 3.32681 112.009L6.137 109.646C6.70785 109.166 6.86347 108.343 6.51051 107.662L6.10498 106.881C5.58083 105.793 5.83351 104.566 6.69494 103.842L10.6749 100.495C11.527 99.7786 12.7882 99.7332 13.7216 100.396L14.4707 100.967C15.0803 101.434 15.9183 101.422 16.4901 100.941L19.3003 98.5779ZM27.8764 122.128C27.0967 118.621 25.0173 110.365 24.9899 110.284C24.9301 110.031 24.7715 109.825 24.5493 109.691C24.3195 109.573 24.0687 109.543 23.8308 109.623L7.28235 115.211C7.04333 115.291 6.85095 115.472 6.75237 115.701C6.65549 115.942 6.65515 116.201 6.74974 116.443C6.7569 116.457 6.87536 116.733 7.07341 117.194C7.9532 119.24 10.4036 124.94 11.6447 127.609C12.5502 129.579 14.3238 130.41 16.2808 129.801C17.7904 129.33 19.3377 128.821 20.9157 128.288C22.4021 127.786 23.9076 127.264 25.4403 126.708C27.4371 125.996 28.3503 124.282 27.8764 122.128Z",
    fill: "#FF5757"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.099 197.076C266.375 197.315 266.408 197.743 266.156 198.036L265.923 198.306C265.677 198.592 265.242 198.63 264.965 198.392L253.168 188.224C252.891 187.985 252.864 187.549 253.11 187.264L253.343 186.994C253.596 186.701 254.024 186.67 254.302 186.909L256.377 188.698C256.799 189.061 257.424 189.078 257.883 188.737L258.41 188.345C259.149 187.829 260.083 187.869 260.72 188.417L263.659 190.951C264.288 191.493 264.472 192.417 264.095 193.183L263.763 193.803C263.492 194.308 263.601 194.924 264.023 195.288L266.099 197.076ZM260.848 208.217C261.913 205.756 264.27 199.857 264.289 199.796C264.364 199.616 264.358 199.422 264.283 199.244C264.195 199.073 264.057 198.944 263.878 198.889L251.432 195.021C251.252 194.965 251.057 194.99 250.897 195.085C250.733 195.188 250.619 195.345 250.57 195.532C250.568 195.544 250.519 195.762 250.437 196.128C250.073 197.749 249.059 202.267 248.64 204.423C248.325 206.01 249.033 207.289 250.482 207.777C251.601 208.153 252.759 208.523 253.945 208.892C255.063 209.239 256.202 209.583 257.371 209.918C258.89 210.362 260.192 209.726 260.848 208.217Z",
    fill: "#FF5757"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19569_43796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296,
    height: 242,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchivedConclusionNotFound);
export default __webpack_public_path__ + "static/media/archived-conclusion-not-found.dc9922ecab5ce00eb52a4c71121781a4.svg";
export { ForwardRef as ReactComponent };